import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
export default function useErrorHandling() {
    const navigate = useNavigate()
    function errorHandling(status: number | string) {
        // if (status === 401) {
        //     toast.error("Authentication credentials were not provided.")
        //     // navigate('/auth')
        // }
        if (status === 404) {
            toast.error("Page not found")
            navigate('/org-dashboard')
        }
    }
    return errorHandling
}